import { render, staticRenderFns } from "./BatchCard.vue?vue&type=template&id=5b924baa"
import script from "./BatchCard.vue?vue&type=script&lang=js"
export * from "./BatchCard.vue?vue&type=script&lang=js"
import style0 from "./BatchCard.vue?vue&type=style&index=0&id=5b924baa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports